import React from 'react'
import PropTypes from 'prop-types'
import { Layer, Source } from 'react-map-gl/maplibre'

const CustomRasterLayer = ({ layer }) => {

    const layerOpts = {
      id:     `${layer.id}-layer`,
      source: `${layer.id}-source`,
      ...layer.opts
    }

  return (
    <>
      <Source
        id={`${layer.id}-source`}
        type='raster'
        tiles={[ layer.url ]}
        >
          <Layer {...layerOpts} />
      </Source>
    </>
  )
}

CustomRasterLayer.propTypes = {
  layer: PropTypes.shape({
    id:   PropTypes.string.isRequired,
    url:  PropTypes.string.isRequired,
    opts: PropTypes.object.isRequired,
  }),
}

export default CustomRasterLayer